import { LitElement, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import * as TagNames from './layouts.tagnames';

import Styles from './environment-ribbon.scss?inline';

@customElement(TagNames.EnvironmentRibbon)
export class AtlEnvironmentRibbon extends LitElement {

   @property({ attribute: 'show', type: Boolean }) showEnvRibbon = false;
   @property({ attribute: 'environment', type: String }) envRibbonName = '';

   @state()
   private _hideEnvRibbon = false;

   static styles = [Styles];

   render() {
      if (!this.showEnvRibbon || this._hideEnvRibbon) return nothing;
      return html`<div class="env-name-ribbon-bottom-right"
                     @click=${() => this._hideEnvRibbon = true} 
                     aria-label="Hide the environment ribbon"
                     role="button"
                     tabindex="0">
            <span>${this.envRibbonName}</span>
         </div>`;
   }
}